module.exports = __webpack_public_path__ + "img/ipad-mobile_en.aeb43a0.jpg";